import styled from "styled-components";

export const TitanJackpotAmountBox = styled.div`
   position: absolute;
   top: calc(69%);

   text-align: center;

   color:  ${props => props.theme.colors.brandSecondary};
   ${({theme}) => theme.font.presets.ultra};
   font-size: 1.8em;
   width: 100%;
   
   @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.3em;    
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 1.1em;
    }
`;